import React, { useContext } from 'react';
import { CheckoutContext, ICheckoutState } from '../../store/CheckoutContext';
import { FORM_FIELDS } from '../../helpers/checkout-constants';
import { Grid, TextField } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import DemoConsole from '../demo-console/DemoConsole';

interface Props {
  fieldName: string;
  state: ICheckoutState;
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  handleBlur?: (e: any, name: string) => void;
  demoMessages?: string[];
  showDemoConsole?: boolean;
}
export const GenerateFields: React.FC<Props> = (props: Props) => {
  const { fieldName, state, setState, handleBlur, showDemoConsole, demoMessages = [] } = props;
  const { errors, setErrors } = useContext(CheckoutContext);
  const location = useLocation();

  function handleChange(e: any, name: string) {
    if (errors[name]) {
      const newErrors = { ...errors };
      delete newErrors[name];
      setErrors(newErrors);
    }
    setState({
      ...state,
      [name]: name === 'billingCountry' || name === 'state' ? e.target.value?.toUpperCase() : e.target.value,
    });
  }

  return (
    <>
      {FORM_FIELDS[fieldName]?.map(el => (
        // @ts-ignore
        <Grid item xs={12} sm={el.sm || 12} key={el.name}>
          <TextField
            disabled={location.pathname.includes('demo')}
            required={el.required}
            id={el.name}
            name={el.name}
            label={el.label}
            fullWidth
            autoComplete={el.autoComplete}
            helperText={errors[el.name] || el.helperText || ''}
            error={!!errors[el.name]}
            value={state[el.name]}
            onChange={e => {
              handleChange(e, el.name);
              if (el.saveInStorage) {
                localStorage.setItem(el.name, e.target.value);
              }
            }}
            onBlur={e => {
              if (handleBlur) {
                handleBlur(e, el.name);
              }
            }}
          />
          <DemoConsole isShow={showDemoConsole} messages={demoMessages} />
        </Grid>
      ))}
    </>
  );
};
